import { render, staticRenderFns } from "./Editor.vue?vue&type=template&id=cb9b723a"
import script from "./Editor.vue?vue&type=script&lang=js"
export * from "./Editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cb9b723a')) {
      api.createRecord('cb9b723a', component.options)
    } else {
      api.reload('cb9b723a', component.options)
    }
    module.hot.accept("./Editor.vue?vue&type=template&id=cb9b723a", function () {
      api.rerender('cb9b723a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/helper/Editor.vue"
export default component.exports